export const updateFormLabel = (formState, key, value) => {
    return {
        ...formState,
        labels: {
            ...formState.labels,
            [key]: value
        }    
    }    
};